import { CalendarTodayOutlined, Menu, PeopleAltOutlined, SettingsOutlined } from '@mui/icons-material';
import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Grid, IconButton, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Localization from 'l18n/l18n';
import AuthUser from 'models/auth';
import * as React from 'react';
import { matchPath } from 'react-router';
import { useLocation,useNavigate } from 'react-router-dom';
import Logo from '../assets/images/sihatec-logo.png'; 

const drawerWidth = 240;

export default function SideBar(props) {

  const navigator = useNavigate();
  const { children } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const Img = styled('img')({ 
    maxWidth: 150,
    maxHeight: '100%',
});
let location = useLocation();

const match = (path) => matchPath( {path}, location.pathname);

const isActivePage = (path) => match(path) !== null ;

  const signOut = () => {
    AuthUser.signOut()
    .then(()=>{
      window.location.reload();
    })
    .catch((error)=>{
      //display error here
    });
  };
  const goTo = (page) => {
    navigator(page);
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const styles = {
    icon: {
      color: '#919493',
    },
    activeIcon:{
      color:'#1FBEB5'
    },
    iconWarpper: {
      justifyContent:'center'
    },
    logout: {
      color: '#B74343',
    },
    label:{
      color:'#919493'
    },
    activeLabel:{
      color:'#1FBEB5',
    },
    bg: {
      backgroundColor: '#EEF9F8',
    },
    bgActive: {
      backgroundColor: '#D0F1EF',
    },

  };

 
  const {user_name : name, user_email : email}= AuthUser.currentUser ;
  const drawer = (
    <>
      <Toolbar/>
      <Grid gap={4} container>
      <Grid item xs={12} textAlign="center">
      <Img alt='logo' src={Logo} />
      </Grid>

      <Grid  item xs={12} gap={0} >
      <Grid item sx={12}  justify="center">
      <Avatar sx={{m:'0 auto',my: 1, border:'4px solid #1FBEB5', width:100, height:100}}/>
      </Grid>
      <Grid item xs={12}  justify="center">
        <Grid item xs={12}   textAlign="center">
          <Typography variant='p' sx={{fontWeight: 'bold'}}> الدكتور {name} </Typography>
        </Grid>
        <Grid item xs={12}   textAlign="center">
          <Typography variant='p'  >{email}</Typography>
        </Grid>
      </Grid>
      </Grid>
      <Grid item xs={12}>
      <List>
        <ListItem disablePadding onClick={()=>{goTo('/appointments-calendar');}} >
          <ListItemButton sx={isActivePage('/appointments-calendar')?styles.bgActive:styles.bg} >
            <ListItemIcon sx={styles.iconWarpper}>
              <CalendarTodayOutlined   style={isActivePage('/appointments-calendar')?styles.activeIcon:styles.icon}/>
            </ListItemIcon>
            <ListItemText sx={isActivePage('/appointments-calendar')?styles.activeLabel:styles.label} primary={Localization.translate.appointments_calendar} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={()=>{goTo('/previous-appointments');}}  >
          <ListItemButton sx={isActivePage('/previous-appointments')?styles.bgActive:styles.bg}>
            <ListItemIcon sx={styles.iconWarpper}>
              <ImportContactsRoundedIcon style={isActivePage('/previous-appointments')?styles.activeIcon:styles.icon}/>
            </ListItemIcon>
            <ListItemText sx={isActivePage('/previous-appointments')?styles.activeLabel:styles.label} primary={Localization.translate.previous_appointments} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={()=>{goTo('/patients');}} >
          <ListItemButton sx={isActivePage('/patients')?styles.bgActive:styles.bg}>
            <ListItemIcon sx={styles.iconWarpper}>
              <PeopleAltOutlined style={isActivePage('/patients')?styles.activeIcon:styles.icon}/>
            </ListItemIcon>
            <ListItemText sx={isActivePage('/patients')?styles.activeLabel:styles.label} primary={Localization.translate.patients} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding onClick={()=>{goTo('/account-settings');}}    primary={Localization.translate.account_settings}>
          <ListItemButton sx={isActivePage('/account-settings')?styles.bgActive:styles.bg} > 
            <ListItemIcon sx={styles.iconWarpper}>
              <SettingsOutlined style={isActivePage('/account-settings')?styles.activeIcon:styles.icon}/>
            </ListItemIcon>
            <ListItemText  sx={isActivePage('/account-settings')?styles.activeLabel:styles.label}   primary={Localization.translate.account_settings} />
          </ListItemButton>
        </ListItem>  
      </List>
      <List>
        <ListItem disablePadding onClick={signOut}>
          <ListItemButton>
            <ListItemIcon sx={styles.iconWarpper}>
             <LogoutRoundedIcon style={styles.logout}/>
            </ListItemIcon>
            <ListItemText primary={Localization.translate.sign_out} style={styles.logout}/>
          </ListItemButton>
        </ListItem>
      </List>
      </Grid>
      </Grid>

    </>
  );
  return (
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
   
 
          display:{sm:'none'},
          boxShadow:'none', 
          borderBottom: '1px solid #1FBEB5'
        }}
        style={styles.bg}
      >
         <Toolbar>
          <Grid container>
          <Grid item xs={2} alignSelf="center">
            
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
            >
            <Menu />
          </IconButton>
              </Grid>
              <Grid item xs={10} justify="center" alignSelf="center">
          <Typography variant="h6" noWrap component="div" textAlign={'justify'} dir="ltr">
          <Img alt='logo' src={Logo} sx={{maxWidth:120,p:1}} />
          </Typography>
              </Grid>
            </Grid>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 },   }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            backgroundColor: '#EEF9F8',
          }}
          PaperProps={{
            sx: {
              backgroundColor: '#EEF9F8', 
            }
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            backgroundColor: '#EEF9F8',
          }}
          PaperProps={{
            sx: {
              backgroundColor: '#EEF9F8', 
            }
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
 
          <Toolbar />
          {children}
     
      </Box>
    </Box>
  );
}
